import { TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { Stack } from '@mui/system';
import { setUploadReason } from '../../store/upload/uploadSlice';

const OnBehalfOfField: React.FC = () => {
	const dispatch = useAppDispatch();

	const userName = useAppSelector((state) => state.user.name);
	const userEmail = useAppSelector((state) => state.user.email);
	const reason = useAppSelector((state) => state.upload.uploadReason.reason);

	const [onBehalfOf, setOnBehalfOf] = useState<boolean>(false);
	const [onBehalfOfName, setOnBehalfOfName] = useState('');
	const [onBehalfOfEmail, setOnBehalfOfEmail] = useState('');
	const [validEmail, setValidEmail] = useState<boolean>(true);

	const handleOnBehalfOf = (_event: React.MouseEvent<HTMLElement>, newValue: boolean) => {
		if (newValue !== null) {
			setOnBehalfOf(newValue);
		}
	};

	useEffect(() => {
		if (onBehalfOf) {
			dispatch(
				setUploadReason({
					reason: reason,
					onBehalfOf: true,
					onBehalfOfName: onBehalfOfName,
					onBehalfOfEmail: onBehalfOfEmail,
				})
			);
		} else {
			dispatch(
				setUploadReason({
					reason: reason,
					onBehalfOf: false,
					onBehalfOfName: userName,
					onBehalfOfEmail: userEmail,
				})
			);
		}
	}, [onBehalfOf, onBehalfOfName, onBehalfOfEmail]);

	return (
		<Stack gap={1}>
			<Typography id="processing-reason-radio">Processing this file for:</Typography>
			<ToggleButtonGroup exclusive sx={{ width: '100%' }} value={onBehalfOf} onChange={handleOnBehalfOf}>
				<ToggleButton color="primary" data-testid={'myself-toggle-button'} sx={{ width: '100%' }} value={false}>
					Myself
				</ToggleButton>
				<ToggleButton color="primary" data-testid={'someone-else-toggle-button'} sx={{ width: '100%' }} value={true}>
					Someone Else
				</ToggleButton>
			</ToggleButtonGroup>
			<Stack direction="row" width="100%" gap={1.5} my={1}>
				<TextField
					variant="outlined"
					value={onBehalfOf ? onBehalfOfName : userName}
					onChange={(e) => setOnBehalfOfName(e.target.value)}
					label="Name"
					fullWidth
					data-testid={`on-behalf-of-name`}
					disabled={!onBehalfOf}
				/>
				<TextField
					variant="outlined"
					value={onBehalfOf ? onBehalfOfEmail : userEmail}
					onChange={(e) => setOnBehalfOfEmail(e.target.value)}
					label="Email Address"
					fullWidth
					data-testid={`on-behalf-of-email`}
					onBlur={() => {
						if (!onBehalfOfEmail.endsWith('police.uk')) {
							setValidEmail(false);
						} else {
							setValidEmail(true);
						}
					}}
					disabled={!onBehalfOf}
					error={onBehalfOf && !validEmail}
					helperText={validEmail ? undefined : 'Email Address must end with .police.uk'}
				/>
			</Stack>
		</Stack>
	);
};

export default OnBehalfOfField;
